angular.module('app').config(bookingsRouting);

function bookingsRouting($routeProvider) {
  $routeProvider
    .when('/bookings', {
      pageTitle: 'BOOKINGS',
      template: '<bookings-page></bookings-page>',
      accessPermission: 'index_booking_accountadmin',
      menu: 'bookings',
      authReq: true,
    })
    .when('/bookings/new', {
      pageTitle: 'ADD_BOOKING',
      template: '<booking-page></booking-page>',
      breadcrumb: {
        label: 'BOOKINGS',
        parent: 'bookings',
        ajs: true,
      },
      accessPermission: 'create_booking_accountadmin',
      menu: 'bookings',
      authReq: true,
    })
    .when('/bookings/:id', {
      params: {
        mode: null,
        type: null,
      },
      pageTitle: 'BOOKING',
      template: '<booking-page></booking-page>',
      breadcrumb: {
        label: 'BOOKINGS',
        parent: 'bookings',
        ajs: true,
      },
      accessPermission: 'show_booking_accountadmin',
      menu: 'bookings',
      authReq: true,
    });
}

bookingsRouting.$inject = ['$routeProvider'];
